"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["address"] = "address";
  TranslationKey["addressResults"] = "addressResults";
  TranslationKey["addressSearch"] = "addressSearch";
  TranslationKey["addressType"] = "addressType";
  TranslationKey["addressTypeLabelChannel"] = "addressTypeLabelChannel";
  TranslationKey["addressTypeLabelDelivery"] = "addressTypeLabelDelivery";
  TranslationKey["addressTypeLabelHome"] = "addressTypeLabelHome";
  TranslationKey["addressTypeLabelKyc"] = "addressTypeLabelKyc";
  TranslationKey["addressTypeLabelOther"] = "addressTypeLabelOther";
  TranslationKey["addressTypeLabelSubscription"] = "addressTypeLabelSubscription";
  TranslationKey["area"] = "area";
  TranslationKey["areaPlaceholder"] = "areaPlaceholder";
  TranslationKey["cancel"] = "cancel";
  TranslationKey["cannotGetData"] = "cannotGetData";
  TranslationKey["city"] = "city";
  TranslationKey["cityPlaceholder"] = "cityPlaceholder";
  TranslationKey["confirm"] = "confirm";
  TranslationKey["confirmAddressDelete"] = "confirmAddressDelete";
  TranslationKey["confirmAddressDeleteInfo"] = "confirmAddressDeleteInfo";
  TranslationKey["country"] = "country";
  TranslationKey["defaultHint"] = "defaultHint";
  TranslationKey["deleteAddress"] = "deleteAddress";
  TranslationKey["delivery"] = "delivery";
  TranslationKey["delivery2"] = "delivery2";
  TranslationKey["delivery2Placeholder"] = "delivery2Placeholder";
  TranslationKey["delivery3"] = "delivery3";
  TranslationKey["delivery3Placeholder"] = "delivery3Placeholder";
  TranslationKey["deliveryPlaceholder"] = "deliveryPlaceholder";
  TranslationKey["district"] = "district";
  TranslationKey["districtPlaceholder"] = "districtPlaceholder";
  TranslationKey["errorOccurred"] = "errorOccurred";
  TranslationKey["errorSearchAddressAutocomplete"] = "errorSearchAddressAutocomplete";
  TranslationKey["hintArea"] = "hintArea";
  TranslationKey["hintAutocomplete"] = "hintAutocomplete";
  TranslationKey["hintCity"] = "hintCity";
  TranslationKey["hintCountry"] = "hintCountry";
  TranslationKey["hintDelivery"] = "hintDelivery";
  TranslationKey["hintDistrict"] = "hintDistrict";
  TranslationKey["hintLocality"] = "hintLocality";
  TranslationKey["hintProvince"] = "hintProvince";
  TranslationKey["hintRegion"] = "hintRegion";
  TranslationKey["hintStreetAddress"] = "hintStreetAddress";
  TranslationKey["hintZipCode"] = "hintZipCode";
  TranslationKey["isPrimary"] = "isPrimary";
  TranslationKey["locality"] = "locality";
  TranslationKey["localityPlaceholder"] = "localityPlaceholder";
  TranslationKey["noSuggestions"] = "noSuggestions";
  TranslationKey["province"] = "province";
  TranslationKey["provincePlaceholder"] = "provincePlaceholder";
  TranslationKey["region"] = "region";
  TranslationKey["regionPlaceholder"] = "regionPlaceholder";
  TranslationKey["save"] = "save";
  TranslationKey["searchAddress"] = "searchAddress";
  TranslationKey["searchAddressAutocompleteV2"] = "searchAddressAutocompleteV2";
  TranslationKey["searchAddressPlaceholder"] = "searchAddressPlaceholder";
  TranslationKey["searchForAnAddress"] = "searchForAnAddress";
  TranslationKey["searchedAddress"] = "searchedAddress";
  TranslationKey["startTypingHere"] = "startTypingHere";
  TranslationKey["streetAddress"] = "streetAddress";
  TranslationKey["streetPlaceholder"] = "streetPlaceholder";
  TranslationKey["typeAtLeastThreeCharacters"] = "typeAtLeastThreeCharacters";
  TranslationKey["uniqueId"] = "uniqueId";
  TranslationKey["validationLength"] = "validationLength";
  TranslationKey["validationMaxLength"] = "validationMaxLength";
  TranslationKey["validationMinLength"] = "validationMinLength";
  TranslationKey["validationMinValue"] = "validationMinValue";
  TranslationKey["validationRegex"] = "validationRegex";
  TranslationKey["validationRequired"] = "validationRequired";
  TranslationKey["validationZipCodeStructure"] = "validationZipCodeStructure";
  TranslationKey["zipCodePlaceholder"] = "zipCodePlaceholder";
  TranslationKey["zipcode"] = "zipcode";
  return TranslationKey;
}({});
//# sourceMappingURL=TranslationKey.js.map